exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-grid {\n  display: grid;\n  grid-template-columns: repeat(3, auto);\n  grid-gap: 5px; }\n\n.table-grid-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -ms-flex-align: baseline;\n  align-items: baseline;\n  padding: 5px 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PortfolioDashboard/navigationPages/Component page/LiveHoldings/section1/pieContent.scss
// module id = 881
// module chunks = 0